import { render, staticRenderFns } from "./NavLocaleSelector.vue?vue&type=template&id=3536e816&scoped=true"
import script from "./NavLocaleSelector.vue?vue&type=script&lang=js"
export * from "./NavLocaleSelector.vue?vue&type=script&lang=js"
import style0 from "./NavLocaleSelector.vue?vue&type=style&index=0&id=3536e816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536e816",
  null
  
)

export default component.exports